import { useEffect, useState } from "react";
import * as THREE from "three";

const ThreeBSP = require('three-js-csg')(THREE);
const reduction = 400;

const useFigure = data => {
  const [figure, setFigure] = useState(null);

  useEffect(() => {
    let geometrySelected = new THREE.BoxGeometry(1, 1, 1);

    switch (data.name) {
      case "cylinder":
        geometrySelected =
          data && data.values && data.values.radius && data.values.height
            ? new THREE.CylinderGeometry(data.values.radius / reduction, data.values.radius / reduction, data.values.height / reduction, 50)
            : new THREE.CylinderGeometry(0.4, 0.4, 2, 50);
        break;

      case "torus":
        geometrySelected =
          data && data.values && data.values.radius && data.values.tube
            ? new THREE.TorusGeometry(data.values.radius / reduction, data.values.tube / reduction, 30, 100)
            : new THREE.TorusGeometry(1, 0.3, 16, 100);
        break;

      case "rectangle":
        geometrySelected =
          data && data.values && data.values.width && data.values.height && data.values.length
            ? new THREE.BoxGeometry(data.values.width / reduction, data.values.length / reduction, data.values.height / reduction)
            : new THREE.BoxGeometry(0.4, 0.2, 2);

        break;

      case "tube":

        if (data && data.values && data.values.height && data.values.tube && data.values.radius) {
          let tube1 = new THREE.Mesh(new THREE.CylinderGeometry(data.values.radius / reduction, data.values.radius / reduction, data.values.height / reduction, 50));
          let tube2 = new THREE.Mesh(new THREE.CylinderGeometry(data.values.tube / reduction, data.values.tube / reduction, data.values.height / reduction, 50));
          const tube1BSP = new ThreeBSP(tube1);
          const tube2BSP = new ThreeBSP(tube2);
          var subtract_bsp = tube1BSP.subtract( tube2BSP );
          const mesh = subtract_bsp.toMesh()
          geometrySelected = mesh.geometry;
        }
        break;

      case "rhomboid":
        if (data && data.values && data.values.height && data.values.width && data.values.depth && data.values.angle) {
          let x = (data.values.width /reduction) / 2,
            xLess = (data.values.depth /reduction) / Math.tan(data.values.angle * Math.PI / 180),
            y = (data.values.height/reduction) / 2,
            z = (data.values.depth/reduction) / 2;

          geometrySelected = new THREE.Geometry();

          geometrySelected.vertices.push(
            new THREE.Vector3(-x, -y, z), // 0
            new THREE.Vector3(x, -y, z), // 1
            new THREE.Vector3(-x, y, z), // 2
            new THREE.Vector3(x, y, z), // 3
            new THREE.Vector3(-x+ xLess, -y, -z), // 4
            new THREE.Vector3(x+ xLess, -y, -z), // 5
            new THREE.Vector3(-x+ xLess, y, -z), // 6
            new THREE.Vector3(x+ xLess, y, -z) // 7
          );
      
          /*
              6----7
              /|   /|
            2----3 |
            | |  | |
            | 4--|-5
            |/   |/
            0----1
          */
          
          geometrySelected.faces.push(
            // front
            new THREE.Face3(0, 3, 2),
            new THREE.Face3(0, 1, 3),
            // right
            new THREE.Face3(1, 7, 3),
            new THREE.Face3(1, 5, 7),
            // back
            new THREE.Face3(5, 6, 7),
            new THREE.Face3(5, 4, 6),
            // left
            new THREE.Face3(4, 2, 6),
            new THREE.Face3(4, 0, 2),
            // top
            new THREE.Face3(2, 7, 6),
            new THREE.Face3(2, 3, 7),
            // bottom
            new THREE.Face3(4, 1, 0),
            new THREE.Face3(4, 5, 1),
         );
          
          geometrySelected.computeFaceNormals();
        }
        break;

      default:
        break;
    }
    const geometry = geometrySelected;

    const material = new THREE.MeshStandardMaterial({
      color: 0xaaaaaa,
      roughness: 0.4,
      metalness: 0.4
    });

    const figureSelected = new THREE.Mesh(geometry, material);
    figureSelected.rotateX(Math.PI / 1.5);
    figureSelected.rotateZ(Math.PI / 1.5);
    setFigure(figureSelected);

    return () => {
      geometry.dispose();
      material.dispose();
    };
  }, [data]);

  return {
    figure
  };
};

export default useFigure;
